export * from "./categories-nav-item";
export * from "./departments-nav-item";
export * from "./programs-nav-item";
export * from "./projects-nav-item";
export * from "./rooms-nav-item";
export * from "./room-content-nav-item";

import { CategoriesNavItemComponent } from "./categories-nav-item";
import { DepartmentsNavItemComponent } from "./departments-nav-item";
import { ProgramsNavItemComponent } from "./programs-nav-item";
import { ProjectsNavItemComponent } from "./projects-nav-item";
import { RoomContentNavItemComponent } from "./room-content-nav-item";
import { RoomsNavItemComponent } from "./rooms-nav-item";

export const NavItemsAtoms = [
  CategoriesNavItemComponent,
  ProjectsNavItemComponent,
  ProgramsNavItemComponent,
  RoomsNavItemComponent,
  DepartmentsNavItemComponent,
  RoomContentNavItemComponent
];
